export default __webpack_public_path__ + "assets/selected-checkbox.c62b2070.webp";